import React, { useEffect } from "react";
import { Button } from "@a365/dsys";
import { useIsMobile } from "@a365/core";

const BannerCard2 = ({ bannerData, scrollToAnchor }) => {

  const isMobile = useIsMobile();

    return (
    <div
      className="
      bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/banner/Slide1Tablet.jpg')]
      xl:bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/banner/Slide1Desktop.jpg')]
      relative z-10 bg-cover bg-top text-wrap w-full xl:w-[486px] xl:min-w-[486px] h-[140px] xl:h-[280px] 
      rounded-2xl pb-2 
      px-4 xl:p-6 flex md:ml-auto items-end justify-end flex-col
      max-w-[358px] md:max-w-full
      "
    >
      <Button
        color="primary"
        variant="alt"
        fullWidth={isMobile ?? false}
        size="small"
        icon="arrow"
        classes="w-full xl:flex xl:justify-end"
        onClick={() => scrollToAnchor("section-payments")}
      >
        {bannerData?.slide_1?.right?.cta}
      </Button>
    </div>
  );
};

export default BannerCard2;
